<template>
  <div id="external_pos_synchronisation">
    <PageTitle :title="`POS ${$t('synchronisation')}`" />

    <div class="container">
      <Tabs>
        <TabSection :title="$t('anomalies')">
          <MappingAnomalies v-if="inventory" :inventory="inventory.id"/>
        </TabSection>
        <TabSection :title="$t('external_pos.sync_price')">
          <ExternalPosPriceSync v-if="inventory" :inventory="inventory.id" :currency="inventory.currency"/>
        </TabSection>
      </Tabs>
    </div>
  </div>
</template>

<script>
import PageTitle from "@/components/PageTitle";
import MappingAnomalies from "@/components/inventory/ExternalPosMappingAnomalies";
import ExternalPosPriceSync from "@/components/inventory/ExternalPosPriceSync";

export default {
  name: "ExternalPosSynchronisation",
  components: {PageTitle, MappingAnomalies, ExternalPosPriceSync},

  computed: {
    inventory() {
      return this.$store.state.contextInventory;
    }
  }
}
</script>

<style lang="scss" scoped>

</style>